import React from 'react'

const ProductsPage = () => {
  return (
    <div className='font-extrabold'>
      productPage
    </div>
  )
}

export default ProductsPage
